export default "__VITE_ASSET__500eb9a5__"